var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cabinet"},[(_vm.role === 'admin')?_c('cabinet-admin'):_vm._e(),(_vm.role === 'client')?_c('cabinet-client'):_vm._e(),(_vm.role === 'talent')?_c('cabinet-talent'):_vm._e(),_c('welcome-modal'),_c('success-payment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }